<template>
  <hm-col :grid="true" cols="12" class="grid--row-gap grid--row-same-height grid--dropzone">
    <draggable v-model="internalValue" group="imageUrls">
      <hm-col v-for="img in imageUrls" :key="img.id" class="dropzone__preview-image" cols="2@hd 3@desktop 4@tablet 12@mobile">
        <img v-sky-lightbox="{
               src: img.url,
               group: `${parentId}-${pad}`,
             }"
             :src="img.url"
             class="dropzone__preview-image__img">
        <input-icon-button v-if="!disabledCombined" :border="false" icon="close-text" @click="deleteFile(img.id)" />
      </hm-col>
      <template slot="footer">
        <hm-col v-for="uploadIndex in activeUploads" :key="`uploading-${uploadIndex}`" class="dropzone__preview-image" cols="2@hd 3@desktop 4@tablet 12@mobile">
          <spinner-overlay />
        </hm-col>
        <hm-col v-if="!disabledCombined" :class="['dropzone__wrapper', {'dropzone__wrapper--hover': drag}]" cols="2@hd 3@desktop 4@tablet 12@mobile">
          <vue-dropzone ref="myVueDropzone"
                        :id="`dropzone-${parentId}-${pad}`"
                        :options="dropzoneOptions"
                        :duplicate-check="true"
                        :use-custom-slot="true"
                        :include-styling="false"
                        @vdropzone-success="vDropzoneSuccess"
                        @vdropzone-drag-over="drag = true"
                        @vdropzone-drag-enter="drag = true"
                        @vdropzone-drag-leave="drag = false"
                        @vdropzone-drag-end="drag = false"
                        @vdropzone-drop="drag = false"
                        @vdropzone-file-added="activeUploads++"
                        @vdropzone-error="vDropzoneError">
            <span v-html="$t('inputs.multiImageUploader.dropHere')"></span>
          </vue-dropzone>
        </hm-col>
      </template>
    </draggable>
  </hm-col>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { findIndex, isNil } from 'lodash';
import HmInputMixin from '../../../mixins/HmInputMixin';
import UpdateHotelSettingsMixin from '../../../mixins/UpdateHotelSettingsMixin';
import TimerMixin from '../../../mixins/TimerMixin';
import { getToken } from '../../../lib/util/token';

export default {
  name: 'MultiImageUploader',

  components: {
    vueDropzone: vue2Dropzone,
    draggable,
  },

  mixins: [HmInputMixin, HotelmeisterMixin, TimerMixin],
  props: {
    parentId: {
      type: String,
      required: true,
    },
    pad: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  //

  data() {
    return {
      activeUploads: 0,
      drag: false,
      authToken: null,
      baseApiAddress: window.getBaseApiAddresses(),
      dropzoneOptions: {
        url: `${window.getBaseApiAddresses()}hotel/${this.$root.hotel}/image/${this.parentId}${this.pad ? '/pad' : ''}`,
        thumbnailWidth: 150,
        resizeWidth: 5120,
        resizeQuality: 0.95,
        maxFilesize: 30,
        uploadMultiple: false,
        chunking: false,
        acceptedFiles: 'image/jpeg,image/jpg,image/png,image/webp',
        // forceFallback: true,
        headers: {
          Authorization: `Bearer ${window.getToken(this.$root.hotel)}`,
        },
      },
    };
  },

  computed: {
    imageUrls: function () {
      if (isNil(this.internalValue)) return [];

      return this.internalValue.map(img => ({
        id: img,
        url: `${this.baseApiAddress}hotel/${this.$root.hotel}/image/${img}?token=${this.authToken}${this.pad ? '&crop=false' : ''}`,
      }));
    },
  },

  watch: {
  },

  created: function () {
    this.authToken = window.getToken(this.$root.hotel);
    this.setInterval(() => {
      this.authToken = window.getToken(this.$root.hotel);
      this.dropzoneOptions.headers.Authorization = `Bearer ${window.getToken(this.$root.hotel)}`;
    }, 120 * 1000);
  },

  updated() {
    this.authToken = window.getToken(this.$root.hotel);
  },

  beforeDestroy() {
  },

  methods: {
    vDropzoneSuccess(file, response) {
      this.activeUploads--;
      this.authToken = getToken(this.$root.hotel);
      this.internalValue.push(response.id);
      this.$refs.myVueDropzone.removeFile(file);
    },
    vDropzoneError() {
      this.activeUploads--;
      this.showErrorMessage(this.$t('inputs.multiImageUploader.errorFileSizeFileType'));
    },
    deleteFile(fileId) {
      this.axios.delete(this.serviceUrls.image.delete(this, this.parentId, fileId))
        .then((response) => {
          this.showMessages(response);
          this.authToken = getToken(this.$root.hotel);
          const idx = findIndex(this.internalValue, it => it === fileId);
          if (idx >= 0) {
            this.internalValue.splice(idx, 1);
          }
        })
        .catch((error) => {
          const response = error.response;

          if (response.status === 404) {
            this.authToken = getToken(this.$root.hotel);
            const idx = findIndex(this.internalValue, it => it === fileId);
            if (idx >= 0) {
              this.internalValue.splice(idx, 1);
            }
          } else {
            this.showMessages(error.response);
          }
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/components/Dashboard';
</style>

<style lang="scss">
  @import '~styles/import';

  .dz-preview {
    display: none!important;
  }

  .dz-default.dz-message {
    display: none;
  }

  .dropzone {
      &__preview-image {
        border: 0.1rem solid $middlegray;
        border-radius: 0.3rem;
        min-height: 12rem;
        position: relative;
        overflow: hidden;
        .inline-button {
          position: absolute;
          bottom: 0.25rem;
          right: 0.25rem;
          width: 32px;
          height: 32px;
          mix-blend-mode: difference;
          cursor: pointer;
        }

        &__img {
          position: absolute;
          cursor: zoom-in;
          max-width: 200%;
          max-height: 100%;
          height: auto;
          top: 50%;
          left: 50%;
          margin-right: -50%;
          transform: translate(-50%, -50%);
          // border-radius: 0.3rem;
        }
      }
      &__wrapper {
        .dz-clickable {
          display: flex;
          flex: 1;
          align-content: center;
          justify-content: center;
          align-items: center;
          justify-items: center;
          text-align: center;
          min-height: 12rem;
          height: 100%;
          border: 0.3rem dashed $middlegray;
          border-radius: 0.3rem;
          cursor: pointer;
        }

        &--hover {
          .dz-clickable {
            border: 0.3rem dashed $mint;
          }
        }
      }
  }

  .grid {
    &--dropzone {
      & > div {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-auto-rows: 1fr;
        grid-column-start: span 12;
        grid-column-gap: 26px;
        grid-row-gap: 26px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/MultiImageUploader.vue